import { SortEnum } from "@finway-group/shared/lib/consts"
import { type QueryParamsObject } from "@finway-group/shared/lib/models"
import { type SortOrder } from "antd/lib/table/interface"
import { type QueryParams } from "~Shared/queries/consts"

// antd understands "ascend and descend" and back end understands "asc and desc"
export const convertSortingToString = (sorting?: { order: SortOrder | string; field: string }) => {
    if (!sorting?.order || !sorting?.field) {
        return ""
    }
    return `&sortBy=${sorting.order === "ascend" ? "asc" : "desc"}(${sorting.field})`
}

export const getSortQueryObject = (sortParams: QueryParams["sortParams"] = []): Pick<QueryParamsObject, "sortBy"> => {
    const filteredSortParams = sortParams.filter((sortParam) => sortParam.sortField && sortParam.sortOption)
    if (filteredSortParams?.length === 0) {
        return {}
    }
    return { sortBy: filteredSortParams.map((sortParam) => `${sortParam.sortOption === SortEnum.ASC ? "asc" : "desc"}(${sortParam.sortField})`).join(",") }
}

export const convertSortOrder = (order: SortOrder): SortEnum => (order === "ascend" ? SortEnum.ASC : SortEnum.DESC)
